<p>current-template works!</p>
